import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from '../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class CommonCfg {
  public apiCommonsEndpoint: string;
}

@Injectable({
  providedIn: 'root'
})
export class CommonCfgService extends CfgService<CommonCfg> {
  json: any = {
    apiCommonsEndpoint: "%{CommonsApiUrl}"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/common.cfg.json`;
  }

  /**
   * Carga las url en el json
   */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
